import { useState } from 'react';
import useSharedApps from '../../utils/sitecoreContext/useSharedApps';
import useSummaryCard from '../BapSummaryCard/hooks/useSummaryCard';
import useSaveBuild from '../../core/apiHooks/useSaveBuild';
import { MY_GARAGE_URL } from '../../utils/constants';
import { gtmSaveBuildCancel, gtmSaveBuildSave } from '../../core/gtm/gtmSaveBuild';
import { selectBodyTypesForGtm } from '../../core/reducers/vehicles';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import { useAppSelector } from '../../core/utils';
import SaveBuild from './index';
const useSaveBuildModal = ({ closeModal, isExitConfirmationModal, componentName, nextUrl }) => {
    var _a;
    const [buildName, setBuildName] = useState('');
    const myGarageUrl = useSharedApps(MY_GARAGE_URL);
    const { nameBadge, vehicle, modelImage, bigExteriorImage } = useSummaryCard();
    const defaultName = `${vehicle.modelYear} ${vehicle.modelName} - ${vehicle.trimName} ${(_a = vehicle.transmission) === null || _a === void 0 ? void 0 : _a.transmissionName}`;
    const { saveBuild, isProcessing, updateBuild, hasSaveBuildData, buildId } = useSaveBuild(buildName !== '' ? buildName : defaultName);
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const gtmPayload = {
        componentType: componentName,
        gtmBodyStyle,
        model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelGtmName,
        trim: vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimGtmName,
        availabilityFlag: inventoryStatus,
    };
    function handleSaveBuildSubmit() {
        gtmSaveBuildSave({
            ...gtmPayload,
            linkText: 'yes',
            linkUrl: myGarageUrl,
        });
        saveBuild({
            onSuccess({ redirectUrl, isUserLoggedIn }) {
                if (isUserLoggedIn && isExitConfirmationModal)
                    return SaveBuild.navigateTo(nextUrl);
                SaveBuild.navigateTo(redirectUrl);
            },
        });
    }
    function handleCloseModal() {
        closeModal();
        setBuildName('');
        gtmSaveBuildCancel({
            ...gtmPayload,
            linkText: 'no',
            linkUrl: '',
        });
    }
    return {
        handleCloseModal,
        handleSaveBuildSubmit,
        isProcessing,
        nameBadge,
        modelImage,
        bigExteriorImage,
        buildName,
        setBuildName,
        defaultName,
        vehicle,
        updateBuild,
        hasSaveBuildData,
        buildId,
    };
};
export default useSaveBuildModal;
